import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TableColumnsService } from '@app/_shared/providers/table-columns/table-columns.service';
import { COLUMN_NAMES_MAPPINGS, BOOKS_MAPPING, FROZEN_BOOKS_MAPPINGS } from '../../table-columns-mappings';
import { SelectionModel } from '@angular/cdk/collections';
import { cloneDeep, remove } from 'lodash';
import { AuthRole, AuthService } from '@app/modules/auth';
import { AffiliateBookType } from '@app/modules/affiliate/structs/affiliate.structs';

@Component({
  selector: 'app-show-hide-columns',
  templateUrl: './show-hide-columns.component.html',
  styleUrls: ['./show-hide-columns.component.scss']
})

export class ShowHideColumnsComponent implements OnInit {

  selection = new SelectionModel<string>(true, []);

  mapping = COLUMN_NAMES_MAPPINGS[this.tableName];
  totalColumns = [];
  frozenColumns = FROZEN_BOOKS_MAPPINGS[this.tableName];
  is_dealer = this.authService.accessTokenObj.role === AuthRole.SUPERDEALER;

  constructor(
    @Inject(MAT_DIALOG_DATA) private tableName: string,
    private dialogRef: MatDialogRef<ShowHideColumnsComponent>,
    private tableColumnsService: TableColumnsService,
    private authService: AuthService
  ) {
    this.totalColumns = this.removeSelectField(BOOKS_MAPPING[tableName]);

    //handeling the case of normal dealer login_source coloumn is not required for the same.
    if(!this.is_dealer && tableName === AffiliateBookType.STATUS) {
      this.totalColumns =  this.totalColumns.filter((val)=> val !== 'login_source')
    }


    tableColumnsService.getColumns(tableName).subscribe((response: string[]) => {
      response = this.removeSelectField(response);
      response.forEach(row => this.selection.select(row));
    });
  }

  ngOnInit(): void {
  }

  // To remove select field (row checkbox) from showing in show hide
  removeSelectField(fields: string[]): string[] {
    const tempFields = cloneDeep(fields);
    return remove(tempFields, el => { return (el !== 'strategy_type' && el !== 'position_type') });
  }

  closeDialog(response?) {
    this.dialogRef.close(response);
  }


  addColumns() {
    const selected = cloneDeep(this.selection.selected);
    this.tableColumnsService.setColumns({ key: this.tableName, data: selected }).subscribe((response) => {
      this.closeDialog(response);
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.totalColumns.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

    if (this.isAllSelected()) {
      this.totalColumns.forEach(row => {
        if (!this.isFrozen(row)) {
          this.selection.deselect(row);
        }
      })
    } else {
      this.totalColumns.forEach(row => {
        this.selection.select(row);
      })
    }

  }

  isFrozen(column: string) {
    return this.frozenColumns && this.frozenColumns.includes(column);
  }
}
